module.exports = __webpack_public_path__ + "assets/img/returnBtn-956faaa8.png";